import { ContentsHeader } from 'app-template-lib/components/layout-panel';
import { IRoute } from 'app-template-lib/utils';
import { TContentsContentParams, TContentsHeaderParams } from '../../../shared/t-contents-params';
// import { MainContents } from './components/main-contents';
import { TopPage } from './top/toppage.container';
import { JigyoListPage } from './jigyoList/jigyoList.container';
import { jigyoDetailPage } from './jigyoDetail/jigyoDetailPage.container';

/**
 * React Router の Route Itemws
 */
export const routeItems: IRoute<TContentsHeaderParams, TContentsContentParams>[] = [
    {
        id: '455402bd-bff2-4e3f-9410-7c6b17e267c5',
        title: 'TOP',
        pathname: '/toppage/',
        path: '/toppage/:lgcode/:jigyoYear/',
        isBack: true,
        mainContents: [
            {
                id: 'e66948f3-b1cb-4cb1-a235-02c2740c60de',
                tabTitle: '',
                header: {
                    title: 'Mainタイトル',
                    isSave: true,
                    params: null,
                    element: ContentsHeader,
                },
                content: { params: null, element: TopPage },
            },
        ],
        topContents: [],
        bottomContents: [],
        leftContents: [],
        rightContents: [],
    },
    {
        id: '0f796577-7942-8c5d-763e-c7161a963c56',
        title: 'List',
        pathname: '/list/',
        path: '/list/:lgcode/:jigyoYear/',
        isBack: true,
        mainContents: [
            {
                id: '34f44201-c3b9-0474-e1c9-1bd1397aa5d4',
                tabTitle: '',
                header: {
                    title: 'Mainタイトル',
                    isSave: true,
                    params: null,
                    element: ContentsHeader,
                },
                content: { params: null, element: JigyoListPage },
            },
        ],
        topContents: [],
        bottomContents: [],
        leftContents: [],
        rightContents: [],
    },
    {
        id: 'a353883e-4204-5a1b-7eb0-a56a91b3b3d4',
        title: 'Detail',
        pathname: '/detail/',
        path: '/jigyodetail/:lgcode/:jigyoYear/:jigyoID/',
        isBack: true,
        mainContents: [
            {
                id: '1544905d-c0f5-0959-b8c4-940ecb766303',
                tabTitle: '',
                header: {
                    title: 'Mainタイトル',
                    isSave: true,
                    params: null,
                    element: ContentsHeader,
                },
                content: { params: null, element: jigyoDetailPage },
            },
        ],
        topContents: [],
        bottomContents: [],
        leftContents: [],
        rightContents: [],
    },
];
